import { useCallback } from 'react';
import { useInfiniteResource } from 'hooks/useInfiniteResource';
import salesforceAccountsService from 'services/salesforceAccountsService';

const PER_PAGE = 25;

const useAccountFundraisings = (accountId, filters = {}, sort = {}) => {
	const fetchFn = useCallback(
		async (page) => {
			if (!accountId) return { data: [], totalCount: 0 };
			return await salesforceAccountsService.getFundraisings(accountId, page, PER_PAGE, filters, sort);
		},
		[accountId, filters, sort]
	);

	const { data, totalCount, loading, loadingMore, error, hasMore, loadMore, refresh } =
		useInfiniteResource({ fetchFn });

	return {
		fundraisings: data,
		totalCount,
		loading,
		loadingMore,
		error,
		hasMore,
		loadMore,
		refresh,
	};
};

export default useAccountFundraisings;
